import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackVisit } from "@/lib/track";

/* Fires a first-party pageview on every route change.

   Placed inside <BrowserRouter> so it can use useLocation. Uses a ref-based
   dedupe so a re-render with the same location doesn't fire twice — some
   guards remount their <Outlet /> and would otherwise cause double-counts.

   Includes ?search but strips the URL hash (used for Google-OAuth
   session_id in-flight) to avoid leaking auth tokens to the analytics
   endpoint. */
export function VisitTracker() {
  const location = useLocation();
  const lastRef = useRef(null);
  useEffect(() => {
    const path = location.pathname + (location.search || "");
    // Skip auth-callback intermediary — it exists only to consume #session_id.
    if (location.hash && location.hash.includes("session_id=")) return;
    if (lastRef.current === path) return;
    lastRef.current = path;
    trackVisit(path);
  }, [location.pathname, location.search, location.hash]);
  return null;
}
